import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';



import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import {
  USER_PRODUCT_ACCEPT, USER_PRODUCT_RETURN_TYPE, USER_PRODUCT_CTO_REQUESTID, USER_PRODUCT_CTO_TRACKID,
  USER_PRODUCT_CTO_SESS
} from '../../manage-product.config';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;
@Injectable()
export class UserListService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService,
    private utilityService: UtilityService,
    private adobeAnalyticsService: AdobeAnalyticsService) { }

  userProductDetails(requestUrl, requestInfoObj) {
    return this.httpClientService.authorizedPut(requestUrl, requestInfoObj)
      .pipe(
       map((resp: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(resp);
        return resp.body;
      })
      ,catchError( this.handleError ));
  }

  fetchGridData(dataurl) {
    return this.httpClientService.get(dataurl)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  unAssignUser(url, companyId, reqObj) {
    const headers = new HttpHeaders();
    const unAssignUrl = url + companyId + '/licenses/bulk';
    return this.httpClientService.authorizedPut(unAssignUrl, reqObj, headers)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  setUpdateProduct(url, data) {
    const descObj = {};
    descObj['name'] = data.productDesc;
    const newUrl = url + data.clientId;
    return this.httpClientService.authorizedPatch(newUrl, descObj)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      }
      ),catchError( this.handleError ));
  }


  handleError = (error) => {
    return throwError(error);
  }

  getProdutPriceDetails(dcmCode: string, ctnNumber: string) {
    const requestObject = {};
    requestObject['credentialType'] = 'MOBILEIDENTIFIER';
    requestObject['credentialId'] = ctnNumber;
    requestObject['dcmCode'] = dcmCode;
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().getProductAndPriceDetailsFromCSI,
      requestObject).pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res.body);
        return res.body;
      }),catchError( this.handleError ));
  };

  // Page Load
  createPageLoadProperties(dcmcodes, url: string, title: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_SINGLE_PRODUCT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_MANAGE_USERS;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    let sku;
    for (const lineItem of dcmcodes) {
      sku = (sku === undefined) ? lineItem : sku + '|' + lineItem;
    }
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SKU] = sku;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }
}
